import {useMappedState} from 'redux-react-hook'
import ApiSdk from 'services/callApi'

function useUserInfo () {
  const {userLogout} = ApiSdk.common
  const mapState = state => ({
    userInfo: state?.userData?.userInfo || []
  })
  return {
    ...useMappedState(mapState),
    userLogout
  }
}

export default useUserInfo
